<template>
  <v-main class="page-mission page-mission-main"
          :class="{ 'has-ticket' : missionOverview.ticketInUse }"
          style="background-color: #9997F0">
    <AppBar hide-back dark title="미션" color="#9997F0">
      <template #end>
<!--        <v-btn text @click="goTutorial">임시 튜토리얼</v-btn>-->
      </template>
    </AppBar>
    <v-layout fill-height column class="mission-main-contents">
      <v-container fluid class="mission-main-header">
        <h4 class="mission-main-title">
          🔎 내 마음, 나도 잘 모를 땐
        </h4>
        <section class="d-flex">
          <MissionCard v-bind="weather"
                       :busy="isLoadings.weather"
                       @click="onClickWeather"
          />
          <MissionCard v-bind="mindnote"
                       :busy="isLoadings.mindnote"
                       @click="onClickMindnote"
          />
        </section>
      </v-container>
      <article class="mission-main-body">
        <v-container fluid>
          <MissionAchievement v-model="missionOverview.totalMissionRate"
                              @onClick="onClickAchievement" />
          <MissionSolutionList
              ref="missionSolutionList"
              @click-mission="handleClickMissionUnit"
              :lastMissionDay="missionOverview.lastMissionDay"
              :activeMissionDay="missionOverview.activeMissionDay"
              :missionDays="missionOverview.missionDays"
              :todayMissions="todayMissions"
              :selectedDay="selectedDay"
              :todayIndex="todayIndex"
          />
        </v-container>
      </article>
    </v-layout>
    <!-- 티켓이 없는 경우 -->
    <div v-if="!missionOverview.ticketInUse || isLoadings.missionTicket" class="mission-no-ticket">
      <dl v-if="!missionOverview.ticketInUse && !isLoadings.missionTicket">
        <dt>
          <span>티켓으로 이용할 수 있는 서비스예요.</span>
          현재 이용중인 티켓이 없어요
        </dt>
        <dd style="width: 214px">
<!--          <v-btn color="primary" class="btn-basic"-->
<!--                 large block depressed-->
<!--                 @click="ticket = '12345'"-->
<!--          >-->
<!--            내 티켓 보러가기-->
<!--          </v-btn>-->
          <v-btn color="primary" class="btn-basic"
                 large block depressed
                 @click="movePage('/fo/myTicket')"
          >
            내 티켓 보러가기
          </v-btn>
        </dd>
      </dl>
      <v-overlay :value="isLoadings.missionTicket" absolute opacity="0">
        <v-progress-circular color="primary"
                             indeterminate />
      </v-overlay>
    </div>
    <!-- // 티켓이 없는 경우 -->
    <BottomMenu :current="2" />

    <router-view />
  </v-main>
</template>

<script>
import BottomMenu from '@/components/layout/BottomMenu.vue'
import MissionCard from '@/components/mission/Card.vue'
import MissionAchievement from '@/components/mission/Achievement.vue'
import MissionSolutionList from '@/components/mission/SolutionList.vue'
import store from '@/store'
import {mixinAuth, mixinRemote} from '@/mixins'

export default {
  name: 'MissionMainIndex',
  components: {
    MissionCard,
    MissionAchievement,
    MissionSolutionList,
    BottomMenu
  },
  data: () => ({
    tutorialVisible: true,
    isLoadings: {
      weather: false,
      mindnote: false,
      missionTicket: false
    },
    weather: null,
    mindnote: null,

    ticket: null,
    progress: null,
    missionOverview:{},
    todayMissions: null,
    todayIndex: 0,
    selectedDay: 0
  }),
  mixins: [mixinRemote, mixinAuth],
  computed: {
    queryDay () {
      return Number(this.$route.query.selectedDay)
    }
  },
  created () {
    // 처음 시작시
    if (!this.memberInfo.missionTutorial) {
      this.goTutorial()
    } else {
      this.getOverview();
    }
  },
  activated () {},
  methods: {
    goTutorial () {
      this.$router.push({ name: 'MissionTutorialIndex' }).catch(() => {})
    },
    async getOverview() {
      window.scrollTo(0, 0)
      Object.entries(this.isLoadings).forEach(([key]) => {
        this.isLoadings[key] = true;
      });
      await store.dispatch('getMissionOverview')
          .then(res => {
            if (res.data != null) {
              this.missionOverview = res.data
              const {completedMindNote, completedMindWeatherScore} = this.missionOverview
              let weatherValueArr = [
                {type: 'weather', write: false, typeCode: '', value: [null]},
                {type: 'weather', write: true, typeCode: 'WEATHER_01', value: [9, 10]}, // 맑음
                {type: 'weather', write: true, typeCode: 'WEATHER_02', value: [7, 8]}, // 보통
                {type: 'weather', write: true, typeCode: 'WEATHER_03', value: [4, 5, 6]}, // 구름
                {type: 'weather', write: true, typeCode: 'WEATHER_04', value: [2, 3]}, // 흐림
                {type: 'weather', write: true, typeCode: 'WEATHER_05', value: [0, 1]}  // 태풍
              ]

              let foundWeather = weatherValueArr.find(item => item.value.some(v => v === completedMindWeatherScore));
              this.mindnote = {type: 'mindnote', write: completedMindNote}
              this.weather = foundWeather || weatherValueArr[0]

              let selectedDay = this.missionOverview.missionDays.find(x => Number(x.thday) == (this.queryDay ? this.queryDay : this.missionOverview.activeMissionDay))
              this.handleClickMissionUnit(selectedDay)
            }
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {
            Object.entries(this.isLoadings).forEach(([key]) => {
              this.isLoadings[key] = false;
            });
          })
    },
    onClickWeather () {
      this.unitDetail(this.mindWeatherUnit.unitUseNo, this.mindWeatherUnit.freeYn, 0, 0, this.mindWeatherUnit.cmpltYn, this.mindWeatherUnit.lock)
    },
    onClickMindnote () {
      this.unitDetail(this.mindNoteUnit.unitUseNo, this.mindNoteUnit.freeYn, 0, 0, this.mindNoteUnit.cmpltYn, this.mindNoteUnit.lock)
    },
    onClickAchievement () {
      this.movePage('/fo/travelMap')
    },
    handleClickMissionUnit(day) {
      this.selectedDay = Number(day.thday)
      if (day.inactive) {
        this.$alert('체험권 이어하기를 통해<br/>더 많은 미션을 경험해 보세요!')
            .then(() => {
              this.selectedDay = this.missionOverview.activeMissionDay
              this.getTodayMissionUnits()
            })
        return false
      }
      if (this.missionOverview.activeMissionDay < this.selectedDay) {
        this.$alert('어떤 여행이 기다리고 있을까요?<br/>기대해 주세요:)')
            .then(() => {
              this.selectedDay = this.missionOverview.activeMissionDay
              this.getTodayMissionUnits()
            })
        return false
      }
      this.getTodayMissionUnits()
    },
    async getTodayMissionUnits() {
      this.$refs.missionSolutionList.moveToGroup(this.selectedDay)
      this.$router.replace({ query: { selectedDay: this.selectedDay }}).catch(()=>{})
      await store.dispatch('getTodayMissionUnits', this.$_payload({'day': this.selectedDay}, {}))
          .then(res => {
            if (res.data != null) {
              this.todayMissions = res.data;
              this.todayIndex = 0
              this.todayMissions.forEach((element, index) => {
                if (element.cmpltYn == 'Y') {
                  this.todayIndex = index + 1
                }
              })
            }
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {
          })
    }
  }

}
</script>

<style lang="scss">
.v-application {
  scroll-snap-type: y mandatory;
  .mission-main-header, .mission-main-body {
    scroll-margin-top: calc(56px + #{var(--system-bar-height)});
    scroll-snap-align: start;
  }
}
</style>
